import { render } from "./Help.vue?vue&type=template&id=0eb99b0b"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"
script.render = render

export default script